/**
 * Медиа лежат в корне репозитория /portfolio и доступны как /portfolio/... через symlink public/portfolio.
 */

export const PORTFOLIO_BASE = "/portfolio";

/** Собрать URL к файлу в portfolio (корень или подпапка). */
export function portfolioFileUrl(...pathParts) {
  return [PORTFOLIO_BASE, ...pathParts.map((p) => encodeURIComponent(p))].join("/");
}

/** @typedef {{ id: string, kind: 'gallery'|'video', titleKey: string, descKey?: string, featured?: boolean, order?: number, folder?: string, cover?: string, images?: string[], file?: string }} PortfolioProject */

/** @type {PortfolioProject[]} */
export const portfolioProjects = [
  {
    id: "admin-panel",
    kind: "gallery",
    order: 9,
    featured: true,
    titleKey: "portfolio.items.adminPanel.title",
    descKey: "portfolio.items.adminPanel.desc",
    folder: "AdminPanel",
    cover: "photo_2023-09-03_20-29-40.jpg",
    images: [
      "photo_2023-09-03_20-29-40.jpg",
      "photo_2023-09-03_20-30-01.jpg",
      "photo_2023-09-17_03-02-11.jpg",
      "photo_2023-11-16_18-17-25.jpg",
      "photo_2023-11-16_23-50-56.jpg",
    ],
  },
  {
    id: "lardi-trans",
    kind: "gallery",
    order: 10,
    featured: true,
    titleKey: "portfolio.items.lardiTrans.title",
    descKey: "portfolio.items.lardiTrans.desc",
    folder: "Lardi-Trans",
    cover: "Основная страница 1.png",
    images: [
      "Основная страница 1.png",
      "Основная страница 2.png",
      "Основная страница 3.png",
      "Реклама на сайте.png",
      "Страховая карта.png",
    ],
  },
  {
    id: "regemsal",
    kind: "gallery",
    order: 11,
    featured: true,
    titleKey: "portfolio.items.regemsal.title",
    descKey: "portfolio.items.regemsal.desc",
    folder: "Regemsal",
    cover: "Основа.jpeg",
    images: ["Основа.jpeg", "Основа 1.jpeg", "Основа 2.jpeg", "Основа 3.jpeg", "Основа 4.png"],
  },
  {
    id: "tut-az",
    kind: "gallery",
    order: 12,
    featured: true,
    titleKey: "portfolio.items.tutAz.title",
    descKey: "portfolio.items.tutAz.desc",
    folder: "Tut.az",
    cover: "Основная.png",
    images: ["Основная.png", "Страница товара .png"],
  },
  {
    id: "project-manager",
    kind: "gallery",
    order: 14,
    featured: false,
    titleKey: "portfolio.items.projectManager.title",
    descKey: "portfolio.items.projectManager.desc",
    folder: "ProjectManager",
    cover: "photo_2024-02-12_22-59-36.jpg",
    images: [
      "photo_2024-02-12_22-59-36.jpg",
      "photo_2024-02-12_22-59-36 (2).jpg",
      "photo_2024-02-12_22-59-36 (3).jpg",
    ],
  },
  {
    id: "jsdelivr",
    kind: "gallery",
    order: 14,
    featured: false,
    titleKey: "portfolio.items.jsdelivr.title",
    descKey: "portfolio.items.jsdelivr.desc",
    folder: "jsdelivr",
    cover: "stats.png",
    images: ["stats.png", "stats 2.png", "stats 3.png", "Network 1.png", "Network 2.png"],
  },
  {
    id: "lg2",
    kind: "gallery",
    order: 15,
    featured: false,
    titleKey: "portfolio.items.lg2.title",
    descKey: "portfolio.items.lg2.desc",
    folder: "lg2",
    cover: "main.png",
    images: ["main.png", "main 2.png", "main 3.png", "main 4.png"],
  },
  {
    id: "podriadchik",
    kind: "gallery",
    order: 7,
    featured: false,
    titleKey: "portfolio.items.podriadchik.title",
    descKey: "portfolio.items.podriadchik.desc",
    folder: "Подрядчик",
    cover: "Основной экран.png",
    images: [
      "Основной экран.png",
      "Маркетплейс.png",
      "Мои компании.png",
      "Настройки компании.png",
      "Страница маркет плейса.png",
      "Фабрики и заводы.png",
      "Чат.png",
    ],
  },
  {
    id: "api-boost",
    kind: "gallery",
    order: 1,
    featured: false,
    titleKey: "portfolio.items.apiBoost.title",
    descKey: "portfolio.items.apiBoost.desc",
    folder: "API boost",
    cover: "ScreenShot Tool -20260419030631.png",
    images: [
      "ScreenShot Tool -20260419030631.png",
      "ScreenShot Tool -20260419030649.png",
      "ScreenShot Tool -20260419030736.png",
      "ScreenShot Tool -20260419030803.png",
    ],
  },
  {
    id: "alivaria",
    kind: "gallery",
    order: 2,
    featured: false,
    titleKey: "portfolio.items.alivaria.title",
    descKey: "portfolio.items.alivaria.desc",
    folder: "Alivaria",
    cover: "ScreenShot Tool -20260419022927.png",
    images: [
      "ScreenShot Tool -20260419022927.png",
      "ScreenShot Tool -20260419022945.png",
      "ScreenShot Tool -20260419023002.png",
      "ScreenShot Tool -20260419023013.png",
      "ScreenShot Tool -20260419023057.png",
    ],
  },
  {
    id: "bel-inter",
    kind: "gallery",
    order: 3,
    featured: false,
    titleKey: "portfolio.items.belInter.title",
    descKey: "portfolio.items.belInter.desc",
    folder: "Bel Inter",
    cover: "ScreenShot Tool -20260419021939.png",
    images: [
      "ScreenShot Tool -20260419021939.png",
      "ScreenShot Tool -20260419022025.png",
      "ScreenShot Tool -20260419022116.png",
      "ScreenShot Tool -20260419022139.png",
      "ScreenShot Tool -20260419022206.png",
    ],
  },
  {
    id: "bitcoin-empire",
    kind: "gallery",
    order: 4,
    featured: false,
    titleKey: "portfolio.items.bitcoinEmpire.title",
    descKey: "portfolio.items.bitcoinEmpire.desc",
    folder: "Bitcoin Empire",
    cover: "ScreenShot Tool -20260419030441.png",
    images: [
      "ScreenShot Tool -20260419030441.png",
      "ScreenShot Tool -20260419030447.png",
      "ScreenShot Tool -20260419030454.png",
    ],
  },
  {
    id: "tringle-space",
    kind: "gallery",
    order: 5,
    featured: false,
    titleKey: "portfolio.items.tringleSpace.title",
    descKey: "portfolio.items.tringleSpace.desc",
    folder: "Tringle Space",
    cover: "ScreenShot Tool -20260419021517.png",
    images: [
      "ScreenShot Tool -20260419021517.png",
      "ScreenShot Tool -20260419021558.png",
      "ScreenShot Tool -20260419021623.png",
      "ScreenShot Tool -20260419021646.png",
      "ScreenShot Tool -20260419021716.png",
      "ScreenShot Tool -20260419021722.png",
      "ScreenShot Tool -20260419021734.png",
    ],
  },
  {
    id: "espireo",
    kind: "gallery",
    order: 5,
    featured: false,
    titleKey: "portfolio.items.espireo.title",
    descKey: "portfolio.items.espireo.desc",
    folder: "espireo",
    cover: "ScreenShot Tool -20260419023222.png",
    images: [
      "ScreenShot Tool -20260419023222.png",
      "ScreenShot Tool -20260419023230.png",
      "ScreenShot Tool -20260419023246.png",
      "ScreenShot Tool -20260419023319.png",
    ],
  },
  {
    id: "husky-help",
    kind: "gallery",
    order: 16,
    featured: false,
    titleKey: "portfolio.items.huskyHelp.title",
    descKey: "portfolio.items.huskyHelp.desc",
    folder: "husky help",
    cover: "ScreenShot Tool -20260419030236.png",
    images: [
      "ScreenShot Tool -20260419030236.png",
      "ScreenShot Tool -20260419030249.png",
      "ScreenShot Tool -20260419030256.png",
      "ScreenShot Tool -20260419030302.png",
      "ScreenShot Tool -20260419030316.png",
    ],
  },
  {
    id: "presentashki",
    kind: "gallery",
    order: 8,
    featured: false,
    titleKey: "portfolio.items.presentashki.title",
    descKey: "portfolio.items.presentashki.desc",
    folder: "presentashki",
    cover: "ScreenShot Tool -20260419030932.png",
    images: [
      "ScreenShot Tool -20260419030932.png",
      "ScreenShot Tool -20260419030956.png",
      "ScreenShot Tool -20260419031002.png",
      "ScreenShot Tool -20260419031016.png",
      "ScreenShot Tool -20260419031026.png",
      "image copy 2.png",
      "image copy 3.png",
      "image copy.png",
      "image.png",
    ],
  },
  {
    id: "v-0076",
    kind: "video",
    order: 100,
    featured: false,
    titleKey: "portfolio.items.v0076.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0076.MP4",
  },
  {
    id: "v-0081",
    kind: "video",
    order: 101,
    featured: false,
    titleKey: "portfolio.items.v0081.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0081.MP4",
  },
  {
    id: "v-0082",
    kind: "video",
    order: 102,
    featured: true,
    titleKey: "portfolio.items.v0082.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0082.MP4",
  },
  {
    id: "v-0083",
    kind: "video",
    order: 103,
    featured: true,
    titleKey: "portfolio.items.v0083.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0083.mov",
  },
  {
    id: "v-0092",
    kind: "video",
    order: 104,
    featured: false,
    titleKey: "portfolio.items.v0092.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0092.MOV",
  },
  {
    id: "v-0088",
    kind: "video",
    order: 105,
    featured: false,
    titleKey: "portfolio.items.v0088.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0088.MOV",
  },
  {
    id: "v-0089",
    kind: "video",
    order: 106,
    featured: false,
    titleKey: "portfolio.items.v0089.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0089.MOV",
  },
  {
    id: "v-0091",
    kind: "video",
    order: 107,
    featured: false,
    titleKey: "portfolio.items.v0091.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0091.MOV",
  },
  {
    id: "v-0094",
    kind: "video",
    order: 108,
    featured: false,
    titleKey: "portfolio.items.v0094.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0094.MOV",
  },
  {
    id: "v-0095",
    kind: "video",
    order: 109,
    featured: false,
    titleKey: "portfolio.items.v0095.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0095.MOV",
  },
  {
    id: "v-0074",
    kind: "video",
    order: 110,
    featured: false,
    titleKey: "portfolio.items.v0074.title",
    descKey: "portfolio.items.video.desc",
    file: "IMG_0074.MP4",
  },
];

export function getSortedPortfolio() {
  return [...portfolioProjects].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function getFeaturedPortfolio(limit = 6) {
  const featured = getSortedPortfolio().filter((p) => p.featured);
  return featured.slice(0, limit);
}
